/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from '../components/App';
import ServerErrorPage from '../components/ServerErrorPage';

const initialState = window.__INITIAL_STATE__;

const root = createRoot(document.getElementById('root'));
root.render(
  <App>
    <ServerErrorPage {...initialState} />
  </App>,
);
